export const APP_NAME = "SIMPELKAMI GPDP";
export const APP_FULL = "Sistem Manajemen Pelayanan Klasis Mimika – Gereja Pentakosta di Papua";
export const APP_TAGLINE = "Terintegrasi dalam Data, Tertib dalam Pelayanan.";
export const APP_TAGLINE_SHORT = "Satu Data • Satu Pelayanan • Satu Klasis";
export const APP_FOOTER = "GPDP Klasis Mimika • Kabupaten Mimika • Papua Tengah";
export const GPDP_LOGO = "/logo-gpdp.png";
export const GPDP_LOGO_ALT = "Logo GPDP — Gereja Pentakosta di Papua";

export const ROLE_LABEL = {
  SUPER_ADMIN: "Super Admin",
  ADMIN_KLASIS: "Admin Klasis",
  KETUA_KLASIS: "Ketua Klasis",
  WAKIL_KETUA: "Wakil Ketua Klasis",
  SEKRETARIS_KLASIS: "Sekretaris Klasis",
  WAKIL_SEKRETARIS: "Wakil Sekretaris",
  BENDAHARA_KLASIS: "Bendahara Klasis",
  WAKIL_BENDAHARA: "Wakil Bendahara",
  KOORDINATOR_BIDANG: "Koordinator Bidang",
  BP2K: "BP2K / Pengawas",
  GEMBALA_JEMAAT: "Gembala Jemaat",
  SEKRETARIS_JEMAAT: "Sekretaris Jemaat",
  BENDAHARA_JEMAAT: "Bendahara Jemaat",
  PANITIA: "Panitia",
  VIEWER_INTERNAL: "Viewer Internal",
  PUBLIC_USER: "Pengguna Publik",
};

export const STATUS_META = {
  UNVERIFIED: { label: "Belum Diverifikasi", tone: "muted" },
  PARTIAL: { label: "Sebagian", tone: "gold" },
  SUBMITTED: { label: "Menunggu Review", tone: "info" },
  UNDER_REVIEW: { label: "Sedang Direview", tone: "review" },
  REVISION_REQUIRED: { label: "Perlu Revisi", tone: "warning" },
  VERIFIED: { label: "Terverifikasi", tone: "success" },
  REJECTED: { label: "Ditolak", tone: "destructive" },
  BARU: { label: "Baru", tone: "info" },
  PROSES: { label: "Proses", tone: "warning" },
  TERTUNDA: { label: "Tertunda", tone: "muted" },
  SELESAI: { label: "Selesai", tone: "success" },
  DIBATALKAN: { label: "Dibatalkan", tone: "destructive" },
  DITERIMA: { label: "Diterima", tone: "info" },
  DISPOSISI: { label: "Disposisi", tone: "warning" },
  ARSIP: { label: "Arsip", tone: "muted" },
  DRAFT: { label: "Draft", tone: "muted" },
  ACCEPTED: { label: "Diterima", tone: "success" },
};

// Menu grouping - filtered by role via canSeeMenu
export const MENU = [
  { section: "Utama", items: [
    { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: "LayoutDashboard", roles: "*" },
  ]},
  { section: "Organisasi", items: [
    { key: "jemaat", label: "Jemaat", path: "/jemaat", icon: "Church", roles: "*" },
    { key: "pengurus", label: "Pengurus & Pelayan", path: "/pengurus", icon: "Users", roles: "*" },
    { key: "bidang", label: "Bidang & Komisi", path: "/bidang", icon: "Grid2x2", roles: "*" },
    { key: "anggota-import", label: "Import Anggota", path: "/anggota/import", icon: "FileSpreadsheet", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","SEKRETARIS_JEMAAT","GEMBALA_JEMAAT"] },
  ]},
  { section: "Pelayanan", items: [
    { key: "kalender", label: "Kalender", path: "/kalender", icon: "Calendar", roles: "*" },
    { key: "kalender-ibadah", label: "Kalender Ibadah", path: "/kalender-ibadah", icon: "CalendarClock", roles: "*" },
    { key: "program", label: "Program Kerja", path: "/program", icon: "Target", roles: "*" },
    { key: "bina-usaha", label: "Bina Usaha (Voting)", path: "/bina-usaha", icon: "Lightbulb", roles: "*" },
    { key: "panitia-kantor", label: "Panitia Kantor Klasis", path: "/panitia-kantor", icon: "Building2", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","BENDAHARA_KLASIS","KETUA_KLASIS","BP2K"] },
    { key: "kegiatan", label: "Kegiatan & Foto", path: "/kegiatan", icon: "Camera", roles: "*" },
    { key: "album", label: "Album Kegiatan", path: "/album", icon: "Images", roles: "*" },
  ]},
  { section: "Rapat & Keputusan", items: [
    { key: "rapat", label: "Rapat & Sidang", path: "/rapat", icon: "Handshake", roles: ["SUPER_ADMIN","KETUA_KLASIS","SEKRETARIS_KLASIS","ADMIN_KLASIS","BP2K","KOORDINATOR_BIDANG"] },
    { key: "keputusan", label: "Keputusan", path: "/keputusan", icon: "Gavel", roles: "*" },
    { key: "tindak-lanjut", label: "Tindak Lanjut", path: "/tindak-lanjut", icon: "ListChecks", roles: "*" },
  ]},
  { section: "Administrasi", items: [
    { key: "surat-masuk", label: "Surat Masuk", path: "/surat-masuk", icon: "Inbox", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","WAKIL_SEKRETARIS","KETUA_KLASIS"] },
    { key: "surat-keluar", label: "Surat Keluar", path: "/surat-keluar", icon: "Send", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","WAKIL_SEKRETARIS","KETUA_KLASIS"] },
    { key: "arsip", label: "Arsip Dokumen", path: "/arsip", icon: "FolderArchive", roles: "*" },
  ]},
  { section: "Pelaporan", items: [
    { key: "laporan", label: "Laporan Jemaat", path: "/laporan", icon: "FileBarChart2", roles: "*" },
    { key: "laporan-raker", label: "Laporan RAKER 2026", path: "/laporan-raker", icon: "FileText", roles: ["SUPER_ADMIN","ADMIN_KLASIS","KETUA_KLASIS","SEKRETARIS_KLASIS","BENDAHARA_KLASIS","BP2K","KOORDINATOR_BIDANG"] },
  ]},
  { section: "Keuangan", items: [
    { key: "keuangan", label: "Dashboard Keuangan", path: "/keuangan", icon: "Wallet", roles: ["SUPER_ADMIN","ADMIN_KLASIS","KETUA_KLASIS","BENDAHARA_KLASIS","WAKIL_BENDAHARA","BENDAHARA_JEMAAT","BP2K"] },
    { key: "buku-kas", label: "Buku Kas Program", path: "/buku-kas", icon: "BookOpen", roles: ["SUPER_ADMIN","ADMIN_KLASIS","KETUA_KLASIS","BENDAHARA_KLASIS","WAKIL_BENDAHARA","SEKRETARIS_KLASIS","KOORDINATOR_BIDANG","BP2K"] },
    { key: "anggaran-realisasi", label: "Anggaran & Realisasi", path: "/anggaran-realisasi", icon: "PiggyBank", roles: ["SUPER_ADMIN","ADMIN_KLASIS","KETUA_KLASIS","BENDAHARA_KLASIS","WAKIL_BENDAHARA","BP2K","KOORDINATOR_BIDANG"] },
    { key: "iuran", label: "Iuran Jemaat", path: "/iuran", icon: "Coins", roles: ["SUPER_ADMIN","ADMIN_KLASIS","BENDAHARA_KLASIS","BENDAHARA_JEMAAT","BP2K","GEMBALA_JEMAAT","SEKRETARIS_JEMAAT"] },
  ]},
  { section: "Lainnya", items: [
    { key: "aset", label: "Aset & Inventaris", path: "/aset", icon: "Boxes", roles: "*" },
    { key: "broadcast", label: "Broadcast Pengumuman", path: "/admin/broadcast", icon: "Megaphone", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","KETUA_KLASIS","BP2K"] },
  ]},
  { section: "Sistem", items: [
    { key: "pengguna", label: "Pengguna", path: "/admin/pengguna", icon: "UserCog", roles: ["SUPER_ADMIN","ADMIN_KLASIS"] },
    { key: "undangan", label: "Undangan Jemaat", path: "/admin/undangan", icon: "Mail", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","KETUA_KLASIS"] },
    { key: "reminder-ibadah", label: "Reminder Ibadah", path: "/admin/reminder-ibadah", icon: "BellRing", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","KETUA_KLASIS"] },
    { key: "notifikasi-push", label: "Notifikasi Push", path: "/notifikasi-push", icon: "BellRing", roles: "*" },
    { key: "widget", label: "Sinkron ke Website", path: "/admin/widget", icon: "Globe", roles: ["SUPER_ADMIN","ADMIN_KLASIS","SEKRETARIS_KLASIS","KETUA_KLASIS"] },
    { key: "audit", label: "Audit Log", path: "/admin/audit", icon: "ShieldCheck", roles: ["SUPER_ADMIN","ADMIN_KLASIS","BP2K"] },
    { key: "system-config", label: "Konfigurasi Produksi", path: "/admin/system", icon: "Settings2", roles: ["SUPER_ADMIN"] },
  ]},
];

export function canSee(item, role) {
  if (item.roles === "*") return true;
  return item.roles.includes(role);
}
